<template>
    <Popup :showPopup="currentlyPlaying" addedClass="MMS" :header="header" @close-popup="$emit('close-video-pop')">
        <template v-slot:content>
            <video controls autoplay class="popVid">
                <source :src="currentlyPlaying" :type="playingFileOfType">
            </video>
        </template>
    </Popup>
</template>

<script>
import Popup from '@/components/Popup';

export default {
    name: 'VideoPopup',
    props: ['currentlyPlaying', 'playingFileOfType'],
    components: { Popup },
    computed: {
        header: function(){
            if (this.currentlyPlaying){
                return this.currentlyPlaying.substring(this.currentlyPlaying.lastIndexOf('.') + 1, this.currentlyPlaying.indexOf('?'));
            }
        }
    }
}
</script>